import React, { useEffect, useMemo, useCallback, useState } from "react";
import { Polyline, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L, { Path } from 'leaflet';
import { useSelector, useDispatch } from "react-redux";
// import TextsPolyline from "../modules/PolylineWithTexts";
import TextPolyline from "../modules/TextOnEachSegmentPolyline";
import '../../styles/Pillars04.css'
import { setDistances } from "../../store/reducers/helpersReducer";
import { selectDataLayersViewFidersDistances } from "../../store/selectors/helpersSelector";


const fidersColors = {
    2: '#B5C800',
    3: '#5FA9DD',
    4: '#2854C5',
    'СИП-2': '#B5C800',
    'СИП-3': '#5FA9DD',
    'СИП-4Н': '#2854C5',
}

const fidersWeight = {
    1: 2.5,
    2: 4,
    3: 5.5,
    4: 7,
}

const projectStatusWeight = {
    1: 3.5,
    2: 4.5,
    3: 5.5,
    4: 6.5,
}

const projectStatusColors = {
    1: '#C76179',
    2: '#ff0000',
    4: '#A6832B',
    7: '#ea33f7',

}

const stagesColors = {
    "1": '220,20,60',   // Темно-красный (Препроектное обследование - начало)
    "2": '255,140,0',   // Темно-оранжевый (Рабочая документация - в процессе)
    "3": '0,150,255',   // Глубокий небесно-голубой (Геодезическая разбивка - почти готово)
    "4": '100,230,0'    // Яркий зеленый лайм (Исполнительная съемка - завершено)
}

export const LayerFiders = props => {
    const map = useMap();
    const dispatch = useDispatch();
    const [mapState, setMapState] = useState({ zoom: map.getZoom(), bounds: map.getBounds() });
    // Разделяем селекторы для избежания создания нового объекта при каждом вызове
    const electricityFiltered = useSelector((state) => state.state.electricityFiltered);
    // const dialFilter = useSelector((state) => state.state.filter.dial);
    // const mounted = useSelector((state) => state.state.mounted);
    const printing = useSelector((state) => state.helper.printing);
    const drawing = useSelector((state) => state.helper.drawing);
    const viewFidersDistances = useSelector(selectDataLayersViewFidersDistances)
    const shouldShowDistances = useMemo(() => {
        return (printing && printing.measure) || viewFidersDistances
    }, [printing, viewFidersDistances])

    // Подписываемся на события карты для обновления при перемещении/зуме
    useEffect(() => {
        const handleMapChange = () => {
            setMapState({ zoom: map.getZoom(), bounds: map.getBounds() });
        };

        map.on('zoomend', handleMapChange);
        map.on('moveend', handleMapChange);

        return () => {
            map.off('zoomend', handleMapChange);
            map.off('moveend', handleMapChange);
        };
    }, [map]);

    useEffect(() => {
        setMapState({ zoom: map.getZoom(), bounds: map.getBounds() });
    }, [shouldShowDistances])

    const handleMarkerClick = useCallback((mark) => (e) => {
        console.log(mark)
        if (drawing.state && drawing.source === 'kanban' && drawing.mode === 'points') {
            let segment = null;
            mark.coordinates.forEach((coords, i) => {
                console.log(i)
                if (i === mark.coordinates.length - 1) return null;
                const sw = [Math.min(mark.coordinates[i][0], mark.coordinates[i + 1][0]), Math.min(mark.coordinates[i][1], mark.coordinates[i + 1][1])]
                const ne = [Math.max(mark.coordinates[i][0], mark.coordinates[i + 1][0]), Math.max(mark.coordinates[i][1], mark.coordinates[i + 1][1])]
                const bounds = new L.LatLngBounds(sw, ne)
                console.log(bounds)
                if (bounds.contains(e.latlng)) segment = i
            })
            console.log(segment)
            if (segment === null) return;

            const points = [mark.connected[segment], mark.connected[segment + 1]]
            const coords = [mark.coordinates[segment], mark.coordinates[segment + 1]]
            console.log(points)
            map.fire('signal:kanban:pointclick', {
                mark: {
                    ...mark,
                    fid: mark.id + '_' + points[0].type + '_' + points[0].id + '_' + points[1].type + '_' + points[1].id,
                    points,
                    coords,
                    segment,
                    // type: 'fiders'
                },
                _type: 'fiders'

            });
            return;
        }
        map.fire('openPopup', {
            class: 'fider',
            mark: mark,
            latlng: e.latlng
        })
    }, [map, drawing]);


    // Мемоизируем фильтрацию с правильными зависимостями
    const fiders = useMemo(() => {
        if (!electricityFiltered?.fiders) return [];
        return electricityFiltered.fiders.filter(f => f.type === props.class);
    }, [electricityFiltered.fiders, props.class]);

    // Используем актуальные значения из состояния карты
    const zoom = mapState.zoom;
    const bounds = printing
        ? new L.LatLngBounds(
            [printing.bounds.south, printing.bounds.west],
            [printing.bounds.north, printing.bounds.east]
        )
        : mapState.bounds;

    // console.log(props.class, fiders)

    // Мемоизируем mounted fiders для оптимизации поиска
    // const mountedFidersMap = useMemo(() => {
    //     if (!props.viewMounted || !mounted?.fiders) return new Map();

    //     const fidersMap = new Map();
    //     for (const mountedFider of mounted.fiders) {
    //         if (!fidersMap.has(mountedFider.fid)) {
    //             fidersMap.set(mountedFider.fid, [mountedFider]);
    //         } else {
    //             fidersMap.get(mountedFider.fid).push(mountedFider);
    //         }
    //     }
    //     return fidersMap;
    // }, [props.viewMounted, mounted?.fiders]);
    // console.log(mountedFidersMap)
    // Расчет расстояний
    const calculateDistance = useCallback((coordinates) => {
        let distance = 0;
        for (let i = 1; i < coordinates.length; i++) {
            const prevCoord = coordinates[i - 1];
            const currCoord = coordinates[i];
            const from = new L.LatLng(prevCoord[0], prevCoord[1]);
            const to = new L.LatLng(currCoord[0], currCoord[1]);
            distance += from.distanceTo(to);
        }
        return distance;
    }, []);

    // Расчет общего расстояния для всех фидеров
    useEffect(() => {
        if (!fiders?.length) return;

        let totalDistance = 0;
        for (const fider of fiders) {
            if (fider.coordinates?.length > 1) {
                totalDistance += calculateDistance(fider.coordinates);
            }
        }

        dispatch(setDistances({
            layer: props.class,
            distance: totalDistance.toFixed(0)
        }));
    }, [fiders, props.class, dispatch, calculateDistance]);

    // Условие рендеринга
    if (!electricityFiltered || !fiders || zoom < 15) {
        return null;
    }






    const markers = fiders.map((mark, idx) => {
        // Создаем bounds только один раз
        const markBounds = new L.LatLngBounds(
            new L.LatLng(mark.bounds[0][0], mark.bounds[0][1]),
            new L.LatLng(mark.bounds[1][0], mark.bounds[1][1])
        );

        if (!bounds.intersects(markBounds)) return null;

        let coordinates = mark.coordinates;
        if (coordinates?.length === 1) coordinates = [];

        // Расчет расстояний для отображения
        let distances = [];
        if (shouldShowDistances && coordinates?.length > 1) {
            for (let i = 0; i < coordinates.length - 1; i++) {
                const from = new L.LatLng(coordinates[i][0], coordinates[i][1]);
                const to = new L.LatLng(coordinates[i + 1][0], coordinates[i + 1][1]);
                distances.push(from.distanceTo(to).toFixed(1).replace('.', ',') + 'м');
            }
        }



        // Работа с mounted данными
        // let isMounted = false;
        // let segments = [];
        // let colors = [];
        // let segmentsColors = []
        const dashPattern = mark.class === 'КЛ' ? [20, 20] : null;

        // if (props.viewMounted && (mark.stage === '4' || mark.stage === '3') && mountedFidersMap.get(mark.id)) {
        //     const mountedData = mountedFidersMap.get(mark.id);
        //     if (mountedData) {

        //         mountedData.forEach(mounted => {
        //             // segments.push(mounted.segmentId);
        //             const object1 = mark.connected.findIndex(c => c.type === mounted.object_1_type && c.id === mounted.object_1_fid)
        //             const object2 = mark.connected.findIndex(c => c.type === mounted.object_2_type && c.id === mounted.object_2_fid)
        //             if (object1 !== -1 && object2 !== -1) {

        //                 let color = '0,0,0'
        //                 if (mounted.mount_stage === 1) {
        //                     color = mounted.data.progress < 98 ? '255,0,0' :
        //                         mounted.data.progress > 102 ? '255,160,0' : '0,221,0'
        //                     segments.push(Math.min(object1, object2))
        //                     colors.push(color);
        //                     segmentsColors.push([Math.min(object1, object2), color])
        //                     isMounted = true;

        //                 }

        //             }
        //         });
        //     }
        // }
        // segmentsColors.sort((a, b) => a[0] - b[0])


        // Стили
        // const color = mark.color ? `rgb(${mark.color.split(',').slice(0, 3).join(',')})` : 'black';
        // const textFont = `normal normal ${window.innerWidth < 768 ? 10 : 14}px Arial, sans-serif`;

        // let subfiders = Array.isArray(mark.chains) && mark.chains.length > 1 ? mark.chains.map(c => {

        //     const localSegments = segmentsColors.filter(s => s[0] < c.segment[1])

        //     const tmp = {
        //         coordinates: coordinates.slice(c.segment[0], c.segment[1] + 1),
        //         distances: distances.slice(c.segment[0], c.segment[1] + 1),
        //         segments: localSegments.map(s => s[0] - c.segment[0]),
        //         glowColors: localSegments.map(s => s[1]),
        //         color: fidersColors[mark.sip] || '#000',
        //         weight: fidersWeight[c.chains],
        //         type: mark.type
        //     }
        //     segmentsColors = segmentsColors.filter(s => s[0] >= c.segment[1])
        //     return tmp
        // }) : [{



        // }]
        const isSipClass = mark.sip_class && Array.isArray(mark.sip_class) && mark.sip_class.filter(Boolean).length > 0
        const color = isSipClass ? (fidersColors[mark.sip_class[0]?.type_wire] || '#000') : (fidersColors[mark.sip] || '#000')
        const color2 = isSipClass && mark.sip_class.length === 2 ? (fidersColors[mark.sip_class[1]?.type_wire] || '#000') : null
        const color2Percenage = isSipClass && mark.sip_class.length === 2 ? (Number(mark.sip_class[0]?.qty_chains) / mark.chains) * 100 : null
        let weight = fidersWeight[Array.isArray(mark.chains[0]) ? (mark.chains[0]?.chains || 2) : (mark.chains || 2)]
        if (color2) weight = weight * 1.5
        let glowColors = null
        let glowWidth = mapState.zoom - 6
        if (props.viewNotSipClass && (!mark.sip_class || mark.sip_class.length === 0)) {
            glowColors = mark.coordinates.map(c => '255,0,0')
        }
        if (props.viewMounted) {
            // glowWidth = props.viewProjectStatus ? 18 : 18
            glowColors = mark.mountSegments || null
        }
        console.log(props.viewStagesBackLight)
        if (!props.viewMounted && !props.viewNotSipClass && props.viewStagesBackLight) {
            // glowWidth = 
            glowColors = mark.coordinates.map(c => stagesColors[mark.stage])
        }


        // const data = {
        // coordinates,
        // distances,
        // segments,
        // glowColors: colors,
        // type: mark.type
        // }
        // const layerColor = projectStatusColors[mark.layer.split(' ')[1]] || '#000'
        // if (props.viewProjectStatus) {
        //     subfiders = [...subfiders.map(sf => {
        //         return {
        //             ...sf,
        //             color: layerColor,
        //             weight: sf.weight + 4,
        //             segments: null,
        //             glowColors: null,
        //             distances: null,
        //             type: 'projectStatus'
        //         }
        //     }), ...subfiders]
        // }

        return (
            // subfiders.map((sf, i) => (
            // sf.type === 'fider' ? (
            <TextPolyline
                positions={mark.coordinates}
                // pane="fidersPane"
                interactive={!drawing?.state || (drawing.state && drawing.source === 'kanban' && drawing.mode === 'points')}
                key={printing ? `print_${mark.id}` : drawing?.state ? `drawing_${mark.id}` : `${mark.id}`}
                data={mark.id}
                dashArray={dashPattern}
                dashOffset={0}
                type={mark.type}
                color={color}
                // weight={mark.type === 'fider10-04' ? sf.weight * 2 : sf.weight}
                weight={weight}


                dualLineEnabled={mark.type === 'fider10-04'}
                dualLinePercentage={color2Percenage || 2}
                dualLineColor={color2}

                segmentTexts={distances}
                segmentTextColor={color}
                segmentTextFontFamily={'Arial, sans-serif'}
                segmentTextFontSize={`${window.innerWidth < 768 ? 10 : 13}px`}
                segmentTextOffset={9}
                segmentTextBold={false}
                segmentTextItalic={false}
                segmentTextStroke={true}
                segmentTextStrokeWidth={2}
                segmentTextStrokeColor="#ffffff"
                segmentTextPosition="middle"
                segmentMaxTextCompressionPercent={50}
                segmentMinZoomForText={18}

                {...(mark.type !== 'fider04' && mark.text && {
                    periodicText: mark.text,
                    periodicTextColor: color,
                    periodicTextFontFamily: 'Arial, sans-serif',
                    periodicTextFontSize: `${window.innerWidth < 768 ? 11 : 14}px`,
                    periodicTextStroke: true,
                    periodicTextStrokeWidth: 2,
                    periodicTextStrokeColor: "#ffffff",
                    periodicTextSpacing: 150,
                    periodicTextPosition: "middle",
                    periodicMaxTextCompressionPercent: 70,
                    periodicMinZoomForText: 17
                })}



                strokeEnabled={props.viewProjectStatus && projectStatusColors[mark.status]}
                strokeColor={projectStatusColors[mark.status] || '#000'}
                strokeWeight={weight + (mark.type === 'fider10-04' ? 6 : 3)}
                strokeDashArray={dashPattern}
                strokeDashOffset={0}

                glowEnabled={glowColors}
                glowWidth={glowWidth}
                glowColors={glowColors || ['255, 255, 255']}

                {...(printing && {
                    connected: mark.connected,
                    bounds: markBounds,
                    pos: coordinates.map(coords => L.latLng(coords)),
                    tp_id: mark.tp_id,
                    layer: mark.layer,
                })}

                tags={mark.tags}
                // interactive={false}

                {...((!drawing?.state || (drawing?.state && drawing?.source === 'kanban' && drawing?.mode === 'points')) && {
                    eventHandlers: {
                        click: handleMarkerClick(mark),

                    }
                })}
            >
                {!drawing?.state &&
                    <Tooltip key={`${mark.id}_${idx}_tooltip`} sticky>
                        {mark.layer}
                    </Tooltip>
                }
            </TextPolyline>
            // ) 
            // : (
            //     <Polyline
            //         positions={sf.coordinates}
            //         key={printing ? `print_${mark.id}_${i}` : `${mark.id}_${i}`}
            //         data={mark.id}
            //         color={sf.color}
            //         weight={sf.weight}
            //         dashArray={[35, 35]}
            //         dashOffset={0}
            //     />
            // )
            // ))
        )

        // return (
        //     <TextPolyline
        //         positions={coordinates}
        //         texts={distances}
        //         key={printing ? `print_${mark.id}` : mark.id}
        //         data={mark.id}
        //         type="fider"
        //         color={color}
        //         weight={mark.linewidth * 5}
        //         textColor={color}
        //         textFont={textFont}
        //         textOffset={9}
        //         textBold={false}
        //         textItalic={false}
        //         textStroke={true}
        //         textStrokeWidth={2}
        //         textStrokeColor="#ffffff"
        //         textPosition="middle"
        //         glowEnabled={isMounted}
        //         glowWidth={14}
        //         glowSegments={segments}
        //         glowColors={colors}
        //         maxTextCompressionPercent={50}
        //         minZoomForText={18}
        //         {...(printing && {
        //             connected: mark.connected,
        //             bounds: markBounds,
        //             pos: coordinates.map(coords => L.latLng(coords)),
        //             tp_id: mark.tp_id
        //         })}
        //         tags={mark.tags}
        //         // interactive={false}

        //         {...(!drawing && {
        //             eventHandlers: {
        //                 click: (e) => {
        //                     map.fire('openPopup', {
        //                         class: 'fider',
        //                         mark: mark,
        //                         latlng: e.latlng
        //                     })
        //                 }
        //             }
        //         })}
        //     >
        //         {!drawing &&
        //             <Tooltip key={`${mark.id}_${idx}_tooltip`} sticky>
        //                 {mark.layer}
        //             </Tooltip>
        //         }
        //     </TextPolyline>
        // );
    }).filter(Boolean);

    return markers;
};

LayerFiders.displayName = 'LayerFiders';


